import { channelConstants } from '../_constants';

export function createChannel(state = {}, action) {
  switch (action.type) {
    case channelConstants.CHANNEL_INTEGRATION_REQUEST:
      return {
        channelStatus: {
          requested: true,
          success: false,
          error: false
        }
      }
    case channelConstants.CHANNEL_INTEGRATION_SUCCESS:
      return {
        channelStatus: {
          request: true,
          success: true,
          error: false
        }
      }
    case channelConstants.CHANNEL_INTEGRATION_FAILURE:
      return {
        channelStatus: {
          request: true,
          success: false,
          error: true
        }
      }
    default:
      return {
        channelStatus: state
      }
  }
}

export function channelsReducer(state = {}, action) {
  switch (action.type) {
    case channelConstants.CHANNEL_REDUCER_REQUEST:
      return {
        channels: {
          requested: true,
          success: false,
          error: false
        }
      }
    case channelConstants.CHANNEL_REDUCER_SUCCESS:
      return {
        channels: {
          requested: true,
          success: true,
          error: false
        }
      }
    case channelConstants.CHANNEL_REDUCER_FAILURE :
      return {
        channels: {
          requested: true,
          success: false,
          error: true
        }
      }
    default:
      return {
        channels: state
      }
  }
}